function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { CommonActions } from "@react-navigation/native";
import { useCallback } from "react";
import { usePersistedState } from "@oui/app-core/src/hooks/usePersistedState";
// We need the navigation prop to be generic since this hook is used in different navigation contexts
// and there is not single generic type that satisfies all our uses so we rely on any here and quickly
// cast to a more narrow type for safety within the hook
// eslint-disable-next-line
export var useNavigateToStaticSessionHook = function(props) {
    var navigation = props.navigation;
    var _usePersistedState = _sliced_to_array(usePersistedState('staticSessionCurrentPages', {}), 1), staticSessionPages = _usePersistedState[0];
    var navigateToStaticSession = useCallback(function(param, previousScreenIcon) {
        var contentType = param.contentType, name = param.name;
        var savedPage = staticSessionPages[contentType];
        if (!!savedPage) {
            var _navigation_getParent;
            (_navigation_getParent = navigation.getParent()) === null || _navigation_getParent === void 0 ? void 0 : _navigation_getParent.dispatch(function(state) {
                var newRoutes = _to_consumable_array(state.routes);
                for(var i = 0; i < savedPage + 1; i = i + 1){
                    var params = {
                        slug: contentType,
                        page: i.toString(),
                        title: name,
                        previousScreenIcon: previousScreenIcon
                    };
                    newRoutes.push({
                        name: 'StaticSession',
                        key: "StaticSession-".concat(contentType, "-").concat(i),
                        params: params
                    });
                }
                return CommonActions.reset(_object_spread_props(_object_spread({}, state), {
                    routes: newRoutes,
                    index: newRoutes.length - 1
                }));
            });
        } else {
            navigation.navigate('StaticSession', {
                slug: contentType,
                page: '0',
                title: name,
                previousScreenIcon: previousScreenIcon
            });
        }
    }, [
        navigation,
        staticSessionPages
    ]);
    return {
        navigateToStaticSession: navigateToStaticSession
    };
};
